/**
 * Usage:
 *
 * data-sw-legacy-js
 *
 *
 * If there is an inline script that you cannot extract for whatever reason, but it depends
 * on a global variable defined in one of these modules, you can simply add the above
 * data attribute to the script tag and change the script type to "text/legacy". Once the appropriate
 * legacy module is loaded, the remaining script body will be evaluated. This allows us to leave more
 * of our legacy modules as AMD modules so that we don't increase the size of our static assets.
 *
 */

var $ = require('./../sw-jquery');

var legacyHash = {

  viewWishlistJquery: function() {
    require('js/lib/legacy/view-wishlist-jquery');
  },

  sellingPage: function() {
      require(['js/lib/legacy/product-pricing-legacy'], function(){});
  },

  ieWarning: function() {
    require('js/lib/legacy/ie-check');
  },

  modelPosing: function() {
    require(['js/lib/legacy/model-posing'], function(){});
  },

  printability: function() {
    require(['js/lib/legacy/printability'], function(){});
  },

  followDesigner: function() {
    require('js/lib/legacy/profile-follow');
  },

  shopDetailsTabs: function() {
    require('js/lib/legacy/shop-settings-tab');
  },

  fixPartCount: function() {
    require('js/lib/legacy/part-count-fix-viz');
  },

  emailPreferenceSettings: function() {
    require('js/lib/legacy/email-preferences-settings');
  },

  accountVerifyButton: function() {
    require('js/lib/legacy/verify-account-button');
  },

  csvCatagoryUpdateTool: function() {
    require(['js/lib/legacy/csv-category-update-tool'], function(){});
  },

  csvMarkupUpdateTool: function() {
    require(['js/lib/legacy/csv-markup-update-tool'], function(){});
  },

  modelEditUpdatePage: function() {
    require('js/lib/legacy/model-edit-update-page');
  },

  deactivation: function() {
    require('js/lib/legacy/deactivation');
  },

  ringPopperMaterialSelect: function() {
    require(['js/lib/legacy/ring-popper-material-select'], function(bindMaterialSelect){
      bindMaterialSelect();
    });
  },

  modelEditUpload: function() {
    require(['js/lib/legacy/model-edit-upload'], function(setupUploadButton){
      setupUploadButton();
    });
  },
  
  customMakerShopperForm: function() {
    require(['js/lib/legacy/sw-shopowner-custom-maker-form'], function(){});
  },

  loadTwitter: function () {
    $(function () {
      $.swPortal.loadTwitter();
    });
  },

  userAuthChange: function() {
    require(['js/lib/legacy/user-auth-change-legacy'], function(){});
  },

  myModels: function () {
    require(['js/lib/legacy/my-models'], function(){});
  },

  checkoutConfirm: function () {
    require(['js/lib/legacy/checkout-confirm'], function(){});
  },

  biKPI: function() {
    require(['js/lib/legacy/biKPI'], function(){});
  },

  orderStatusInitDropDownMenu: function() {
    require(['js/lib/legacy/order-status-init-drop-down-menu'], function(){});
  },

  checkoutBilling: function() {
    require(['js/lib/legacy/checkout-billing'], function(){});
  },

  userBilling: function() {
    require(['js/lib/legacy/user-billing'], function(){});
  },

  checkoutShipping: function() {
    require(['js/lib/legacy/checkout-shipping'], function(){});
  },

  payments: function() {
    require(['js/lib/legacy/payments'], function(){});
  },

  makerHeader: function() {
    require(['js/lib/legacy/maker-header'], function(){});
  },

  manufacturerCost: function() {
    require(['js/lib/legacy/manufacturer-cost'], function(){});
  },

  shopSettings: function() {
    require(['js/lib/legacy/shop-settings'], function(){});
  },

  shopInventory: function() {
    require(['js/lib/legacy/shop-inventory'], function(){});
  },
  
  quotingConfirm: function () {
    require(['js/lib/legacy/quoting-confirm'], function(){});
  }
};

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-legacy-js]').each(function() {
    var $el = $(this);
    var legacyFileKey = $el.data('swLegacyJs');

    var script = $el.text();

    legacyHash[legacyFileKey](script);
  });
};
